// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1rE65","header":"Messages_header__2e--9"};